import { render, staticRenderFns } from "./tip-audio.vue?vue&type=template&id=47a5b9a2&scoped=true"
import script from "./tip-audio.vue?vue&type=script&lang=js"
export * from "./tip-audio.vue?vue&type=script&lang=js"
import style0 from "./tip-audio.vue?vue&type=style&index=0&id=47a5b9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5b9a2",
  null
  
)

export default component.exports